import { useContext, useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router";
import axios from "axios";
import { CREWAI_AGENTS_URL } from "../../constants/apiUrl";
import { ACCESS_TOKEN } from "../../constants/constants";
import { getCookie } from "../../helpers/jwt";
import ChatPanel from "./ChatPanel";
import ExecutionPanel from "./ExecutionPanel";
import { base64UrlToUuid } from "../../helpers/shared";

const ChatPage = () => {
  const [lastMessage, setLastMessage] = useState(null);
  const [incomingMessage, setIncomingMessage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [accessToken] = useState(getCookie(ACCESS_TOKEN));
  const [agentDetails, setAgentDetails] = useState({});
  const [agents, setAgents] = useState([]);
  const [agentsLoading, setAgentsLoading] = useState(true);
  // git file info ftom location state
  const location = useLocation();
  const fileInfo = location.state?.fileInfo;
  const [searchParams] = useSearchParams();
  const agentId = base64UrlToUuid(searchParams.get("agentId")) ?? undefined;

  const fetchAgentDetails = async () => {
    try {
      const response = await axios.get(
        `${CREWAI_AGENTS_URL}/agents/${agentId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setAgentDetails(response.data || []);
    } catch (err) {
      console.error("Error fetching agents:", err);
      setAgentDetails([]);
    }
  };

  const fetchAgents = async () => {
    try {
      const response = await axios.get(`${CREWAI_AGENTS_URL}/agents`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setAgents(response.data || []);
    } catch (err) {
      console.error("Error fetching agents:", err);
      setAgents([]);
    } finally {
      setAgentsLoading(false);
    }
  };

  useEffect(() => {
    fetchAgentDetails();
    fetchAgents()
  }, []);

  useEffect(() => {
    if (fileInfo) {
      setSelectedFile(fileInfo);
    }
  }, [fileInfo]);

  const handleChatSubmit = (query, executionId) => {
    setLastMessage({
      id: Date.now().toString(),
      content: query,
      executionId: executionId,
    });
  };

  const handleMessageReceived = (content, isPartial, executionId) => {
    setIncomingMessage({ content, isPartial, executionId: executionId ?? "" });
  };

  return (
   <div className="flex flex-auto overflow-y-hidden h-[calc(100vh-64px)] w-full">
     <div className="container max-w-full h-full flex overflow-hidden">
      <div className="w-[40%] h-full border-r border-gray-200">
        <ExecutionPanel
          lastMessage={lastMessage}
          onMessageReceived={handleMessageReceived}
          selectedFile={selectedFile}
          agentDetails={agentDetails}
        />
      </div>
      <div className="w-[60%] h-full pl-2 pb-1">
        <ChatPanel
          onSendMessage={(message, executionId) =>
            handleChatSubmit(message, executionId)
          }
          agentDetails={agentDetails}
          incomingMessage={incomingMessage}
          selectedFile={selectedFile}
          setSelectedFile={(file) => setSelectedFile(file)}
          agentLists={agents}
          agentsLoading={agentsLoading}
        />
      </div>
    </div>
   </div>
  );
};
export default ChatPage;
